import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as SVG } from "./SVG/spain_flag.svg";

const SpainFlagIcon = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} component={SVG} />
));
export default SpainFlagIcon;
